module.exports = __webpack_public_path__ + "media/images/pic/hero/lion-aef701413ade00ee00873034be45d5ab.webp";